import Vue from 'vue'
import store from './store/store'
import getParameterByName from './util/QueryParams'
import User from './models/User';

export function GetSID()
{
	let querySID = getParameterByName('sid');
	if (querySID != undefined)
	{
		(window as any).__queryOverrideSid = querySID;
		return querySID;
	}

	if ((window as any).__queryOverrideSid) return (window as any).__queryOverrideSid;
	return localStorage.getItem('cv-sid');
}

export function SetSID(sid : string)
{
	if ((window as any).__queryOverrideSid)
	{
		(window as any).__queryOverrideSid = sid;
		return;
	}
	localStorage.setItem('cv-sid', sid);
}

export function SessionIsValid(func : Function)
{
	Vue.set(window, "loadingUserData", true);
	
	let sid = GetSID();
	if (sid == null || sid == undefined)
	{
		Vue.set(window, "loadingUserData", false);
		func(false);
		return;
	}

	Vue.axios.get("userinfo").then(
		(result)=>{
			Vue.set(window, "loadingUserData", false);
			if (result.data.error != undefined)
			{
				localStorage.removeItem("cv-sid");
				func(false);
			}
			else
			{
				store.commit('setUserData', Object.assign(new User, result.data.user));
				func(true);
			}
		},
		(error)=>{
			Vue.set(window, "loadingUserData", false);
			localStorage.removeItem("cv-sid");
			func(false);
		}
	)
}

export function GetUser() : User
{
	return store.state.userdata;
}

export async function ClearSession()
{
    localStorage.removeItem("cv-sid");
	const auth2 = await Vue.GoogleAuth;
	await auth2.signOut();
}